"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "32",
    height: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#35A7F8",
    width: "32",
    height: "32",
    rx: "5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.999 13.618c0-2.7-2.125-4.898-4.738-4.898H8.96l1.683 2.68v11.96h2.603V11.411h4.016c1.177 0 2.134.99 2.134 2.207 0 1.217-.958 2.207-2.134 2.207h-2.569l5.345 7.535h3.002l-3.6-5.393C20.96 17.15 22 15.507 22 13.617z",
    fill: "#FFFFFE"
  })));
};

exports["default"] = _default;